import {useMemo} from 'react';

/**
 *
 *  While searching, we also want to display sections with names that match the search
 */
export const useSectionNameMatch = (
  sectionName: string,
  searchRegex: RegExp | null
) => {
  return useMemo(() => {
    return getIsSectionNameSearchMatch(sectionName, searchRegex);
  }, [searchRegex, sectionName]);
};

export const getIsSectionNameSearchMatch = (
  sectionName: string,
  searchRegex: RegExp | null
) => {
  if (searchRegex == null) {
    return false;
  }

  if (searchRegex.source.includes('?!')) {
    return false;
  }

  return searchRegex.test(sectionName);
};
